"use strict";
// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Humla Health API
 * Humla Health API
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfBasicProfileDto = instanceOfBasicProfileDto;
exports.BasicProfileDtoFromJSON = BasicProfileDtoFromJSON;
exports.BasicProfileDtoFromJSONTyped = BasicProfileDtoFromJSONTyped;
exports.BasicProfileDtoToJSON = BasicProfileDtoToJSON;
exports.BasicProfileDtoToJSONTyped = BasicProfileDtoToJSONTyped;
/**
 * Check if a given object implements the BasicProfileDto interface.
 */
function instanceOfBasicProfileDto(value) {
    if (!('id' in value) || value['id'] === undefined)
        return false;
    if (!('firstName' in value) || value['firstName'] === undefined)
        return false;
    if (!('lastName' in value) || value['lastName'] === undefined)
        return false;
    if (!('avatar' in value) || value['avatar'] === undefined)
        return false;
    if (!('verifiedFacilities' in value) || value['verifiedFacilities'] === undefined)
        return false;
    return true;
}
function BasicProfileDtoFromJSON(json) {
    return BasicProfileDtoFromJSONTyped(json, false);
}
function BasicProfileDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'id': json['id'],
        'firstName': json['firstName'],
        'lastName': json['lastName'],
        'avatar': json['avatar'],
        'verifiedFacilities': json['verifiedFacilities'],
    };
}
function BasicProfileDtoToJSON(json) {
    return BasicProfileDtoToJSONTyped(json, false);
}
function BasicProfileDtoToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'id': value['id'],
        'firstName': value['firstName'],
        'lastName': value['lastName'],
        'avatar': value['avatar'],
        'verifiedFacilities': value['verifiedFacilities'],
    };
}
//# sourceMappingURL=BasicProfileDto.js.map